import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IDeleteDraftJobPayload } from '../types';

export const deleteDraftJob = async (payload: IDeleteDraftJobPayload): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.delete<void>(`/posting-service/postings/${payload.jobPostingId}`, { headers });
};
